import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";
import { GridButtons } from "@/controls/buttons/GridButtons";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import ColorCircleRenderer from "../components/ColorPicker/ColorCircleRendered";
import { DelayCategory } from "../models/CatalogCategory";

type Props = {
	setSelectedRowData: (category: DelayCategory) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};

export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		{
			field: "DelayCategoryName",
			headerName: "Name",
			flex: 1,
			minWidth: 130,
		},
		/* {
      field: "AssetName",
      headerName: "Asset",
      flex: 1,
      minWidth: 130,
    }, */
		{
			field: "DelayCategoryColor",
			headerName: "Color",
			sortable: false,
			flex: 1,
			cellRenderer: ColorCircleRenderer,
			minWidth: 130,
		},
		activeColumnDef<DelayCategory>({ field: "IsActive" }),
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as DelayCategory,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "categoriesContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			sortable: false,
			flex: 1,
			maxWidth: 220,
			filter: false,
			autoHeaderHeight: true,
		},
	];

	return { columnDefs };
};
